import type { FaireProductEntity } from "../../entity_types/product";

export const p_4bayn8dxy8: FaireProductEntity = {
  token: "p_4bayn8dxy8",
  type: "product",
  name: "Fresh Catch De-Puffing Eye Patches | 8 Pack | Summer Edition",
  brandToken: "b_or0vvyanpz",
  brandName: "My Spa Life",
  imageUrl:
    "https://cdn.faire.com/fastly/b2182b12c381b7abdd5ee06e116646ac1fe41b373ca323bb563058b1fb552856.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ad200cd9b2b348d24d91b14b1ec262528e1a7de3f7e6b53f1425e6aa4f1f92f.jpeg",
    "https://cdn.faire.com/fastly/a5a360f34336a4b03aceef2ae9e41fcb874da2ed58348cba26917d950f16bb20.jpeg",
    "https://cdn.faire.com/fastly/5467aad8e1b79e95c92c6e68b500049c1d43f000593876adbae5833c3d3b21d6.jpeg",
  ],
  priceDollars: 5,
  description:
    "The deep-sea secret to a wide-awake, 'fresh-caught' glow\n\nLooking for the \"catch of the day\" for your skincare routine? Dive into these SpaLife sardine eye patches for an instant refresh! These hydrogel undereye masks are specifically formulated to de-puff and smooth the delicate eye area. Packed with moisture-plumping hyaluronic acid undereye masks technology and barrier-strengthening niacinamide eye patches, they’re the ultimate solution for tired eyes.\n\nWhy we love it?\n\n• Tinned Fish Trend: Housed in a viral-worthy, reusable sardine tin—the perfect sustainable self-care gift that looks as good as it works\n• Skin Barrier Support: Infused with Niacinamide (Vitamin B3) to help strengthen and smooth the delicate skin barrier while reducing fluid retention\n• Hydrogel Hug: These unique sardine-shaped hydrogel undereye masks are designed to contour perfectly to your lower lash line for targeted cooling\n\nWorks Best for Targeting:\n\n• Puffiness\n• Dark circles\n• Dullness\n• Fine lines\n• Eye patches for puffy eyes\n• Eye patches for dark circles\n\n\nLET'S DO THIS!\n\n1. Apply to clean & dry under eye area.\n2. Leave on for 15–20 mins.\n3. Remove & discard after use (one-time use only).\n\nRub in excess serum. Marvel at your fresh glow!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:28:40.680Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
